module.exports = __webpack_public_path__ + "img/logo_Uruguai_Ministerio_Ambiente.ae25be8f.png";